import { LitElement, html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import '@fil-global/gds-streamline-icons/webcomponent/fil-icon-close';
import '@fil-global/gds-streamline-icons/webcomponent/fil-icon-custom-info-circle';
import componentStyles from './fil-promotional-banner.styles.js';
import { isMobile } from '@fil-global/shared';

/**
 * @tag fil-promotional-banner
 * @property {boolean} [fixed] Position the component as a fixed element.
 * @property {boolean} [show] show/hide the component
 * @property {'white' | 'blue'} [colour] Colour of the component
 * @fires close.gds.promotional-banner (event: Event) => void
 */
export class FilPromotionalBanner extends LitElement {
  static properties = {
    fixed: { type: Boolean },
    colour: { type: String },
    show: { type: Boolean },
  };

  static styles = [componentStyles];

  constructor() {
    super();
    this.show = false;
    this.fixed = false;
    this.handleResize = this.handleWindowResize.bind(this);
  }

  onClick() {
    this.show = false;
    let evt = new CustomEvent('close.gds.promotional-banner');
    this.shadowRoot.getRootNode().dispatchEvent(evt, { value: this.show });
  }

  onKeypress(event) {
    // check for key 'space'
    if (event.code === 'Space') {
      event.preventDefault();
      this.onClick();
    }
  }
  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('resize', this.handleResize);
  }

  handleWindowResize() {
    let actionSlots = this.querySelectorAll('[slot="action"]');
    if (actionSlots.length) {
      actionSlots[0].setAttribute('size', isMobile() ? 'small' : 'standard');
    }
  }

  render() {
    const classes = {
      [`fil-promotional-banner--${this.variation}`]: this.variation,
      [`fil-promotional-banner--coloured`]: this.colour === 'lightblue' ? true : false,
      [`fil-promotional-banner--fixed`]: !!this.fixed,
    };

    let contentSlot = this.querySelectorAll('[slot="content"]').length;
    let iconSlot = this.querySelectorAll('[slot="icon"]').length;
    let actionSlot = this.querySelectorAll('[slot="action"]').length;
    let titleSlot = this.querySelectorAll('[slot="title"]').length;

    this.handleResize();

    return this.show
      ? html`
          <div class="fil-promotional-banner${classMap(classes)}" role="alert">
            ${iconSlot
              ? html`<div class="fil-promotional-banner__icon">
                  <slot name="icon"></slot>
                </div>`
              : null}
            <div class="fil-promotional-banner__body">
              <div class="fil-promotional-banner__content">
                ${titleSlot ? html`<h5><slot name="title"></slot></h5>` : null}
                ${contentSlot ? html`<slot name="content"></slot>` : null}
              </div>
              ${actionSlot
                ? html`<div class="fil-promotional-banner__action">
                    <slot name="action"></slot>
                  </div>`
                : null}
            </div>
            <div class="fil-promotional-banner__close">
              <fil-icon-close
                @click=${this.onClick}
                @keypress=${this.onKeypress}
                size="16"
                tabindex="0"
                role="button"
                aria-label="Close"
                label="Close"
              ></fil-icon-close>
            </div>
          </div>
        `
      : null;
  }
}

export default FilPromotionalBanner;
